import { PassengerRow } from "@apac/components/checkout";
import { usePassengerTypeString } from "@apac/hooks";
import type { Person } from "@b2bportal/air-booking-api";
import { useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreCheckoutComponent,
  type IPassengerCounts,
  type PassengerType,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { Traveler } from "@b2bportal/traveler-api";
import { TravelProductEnum } from "@hopper-b2b/types";
import { usePassengerSelection } from "./hooks/usePassengerSelection";
import styles from "./PassengerSelection.module.scss";

export interface PassengerSelectionComponentProps
  extends PlatformComponentProps {
  passengerList: Array<Traveler | Person>;
  handleSelectPassenger: (passengerId: string) => void;
  handleEdit: (passengerId: string) => void;
  handleDelete: (passengerId: string) => void;
  allSelectedPassengerIds: string[];
  disabled?: boolean;
  searchPassengerCounts: IPassengerCounts;
  tripDate?: string | Date;
}

export const PassengerSelection = (props: PassengerSelectionComponentProps) => {
  const COMPONENT_KEY = CoreCheckoutComponent.PassengerSelection;
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const {
    allSelectedPassengerIds,
    handleSelectPassenger,
    disabled,
    handleEdit,
    handleDelete,
    passengerList,
    searchPassengerCounts,
    tripDate,
  } = props;

  const { passengersByAge } = usePassengerSelection({
    passengerList: passengerList,
    allSelectedPassengerIds: allSelectedPassengerIds,
    searchPassengerCounts: searchPassengerCounts,
    tripDate: tripDate,
  });
  const getPassengerTypeString = usePassengerTypeString();

  return (
    <div className={block}>
      {Object.entries(passengersByAge)
        .filter(([, passengers]) => passengers?.length > 0)
        .map(([age, passengers]) => {
          return (
            <div className={cn("passenger-age-group")} key={age}>
              <h3 className={cn("group-label")}>
                {getPassengerTypeString(age as PassengerType)}
              </h3>

              <ul className={cn("passenger-group")}>
                {passengers.map((passenger) => {
                  const isSelected = allSelectedPassengerIds.includes(
                    passenger.id
                  );
                  return (
                    <PassengerRow
                      key={passenger.id}
                      passenger={passenger}
                      selected={isSelected}
                      onClick={() => {
                        handleSelectPassenger(passenger.id);
                      }}
                      disabled={disabled}
                      handleEdit={handleEdit}
                      handleDelete={handleDelete}
                      funnell={TravelProductEnum.Flights}
                    />
                  );
                })}
              </ul>
            </div>
          );
        })}
    </div>
  );
};
